<template>
  <div class="container">
    <div class="login-box">
      <div class="login-form">
        <div style="text-align: center">
          <img :src="logoUrl" alt class="info-img" v-if="logoUrl" />
          <img alt class="info-img" src="@/assets/img/placeholder.png" v-else />
        </div>
        <div class="header-info">
          <span class="info">
            <span class="proxy-name">{{ channelName }}</span>
            <span class="name">学员登录</span>
          </span>
        </div>
        <el-form
          label-width="0"
          ref="form"
          style="width: 400px; margin: 0 auto"
        >
          <el-form-item prop="username">
            <el-input
              maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')"
              placeholder="学员账号"
              size="large"
              v-model="loginName"
            >
              <i class="el-input__icon el-icon-user" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              @keyup.enter="loginSubmit"
              placeholder="密码"
              size="large"
              type="password"
              v-model="loginpwd"
            >
              <i class="el-input__icon el-icon-key" slot="prefix"></i>
            </el-input>
          </el-form-item>
          <el-form-item style="position: relative">
            <el-checkbox v-model="isRememberPwd">
              <span class="isRememberPwd-text">记住密码</span>
            </el-checkbox>
            <el-button
              size="mini"
              round
              @click="touristLogin()"
              style="position: absolute; right: 0; top: 7px"
              >游客登录</el-button
            >
          </el-form-item>

          <el-form-item>
            <el-button
              :disabled="!(isTrueTel && isTruePwd)"
              :loading="isLoading"
              @click="loginSubmit"
              class="login-btn"
              type="primary"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import * as CUSTOMER_API from '@/api/ChannelCustomerAPI'
import * as CHANNEL_API from '@/api/ChannelAPI'
export default {
  name: 'login',
  components: {},
  data () {
    return {
      loginName: '',
      loginpwd: '',
      isDisabled: true,
      isTrueTel: false,
      isTruePwd: false,
      isLoading: false,
      isRememberPwd: false,
      channelName: '',
      logoUrl: ''
    }
  },
  mounted () {
  },
  watch: {
    loginName: function (val) {
      let reg = new RegExp(/^[0-9]*$/g).test(val)
      if (reg) {
        // 符合条件
        if (
          val.match(
            /^(((13[0-9]{1})|(15[0-9]{1})|(19[0-9]{1})|(16[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/
          )
        ) {
          this.isTrueTel = true
        } else {
          if (val.length > 11) {
            this.$message.error('请输入正确格式手机号！')
          }
          // this.isTrueTel = false
          this.isTrueTel = true
        }
      } else {
        // 不符合条件
        //  this.$message.error('请输入正确格式手机号！')
        //  this.isTrueTel = false
        this.isTrueTel = true
      }
    },
    loginpwd: function (val) {
      let reg = new RegExp(/^[0-9a-zA-Z]*$/g).test(val)
      if (reg) {
        if (val.length >= 6) {
          this.isTruePwd = true
        } else {
          this.isTruePwd = false
        }
      } else {
        this.isTruePwd = false
        this.$message.error('请输入数字或字母！')
      }
    },

  },
  created () {
    localStorage.removeItem('shangke_token')
    localStorage.removeItem('user_avatar')
    localStorage.removeItem('nickname')
    sessionStorage.removeItem('activeIndex')
    sessionStorage.removeItem('nickname')
    localStorage.setItem('c_no', this.$route.query.c_no)
    sessionStorage.setItem('c_no', this.$route.query.c_no)
    var os = (function () {
      var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isTablet =
          /(?:iPad|PlayBook)/.test(ua) ||
          (isAndroid && !/(?:Mobile)/.test(ua)) ||
          (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
      }
    })()
    if (os.isAndroid || os.isPhone) {
      // console.log(os.isAndroid,os.isPhone,'跳转到h5')
      this.$router.push({ path: '/h5/login', query: { c_no: sessionStorage.getItem('c_no') || localStorage.getItem('c_no') } });
    }

    this.isRememberPwd = JSON.parse(localStorage.getItem('isRememberPwd'))
    if (this.isRememberPwd) {
      this.loginName = localStorage.getItem('shangke_username') || sessionStorage.getItem('shangke_username'),
        this.loginpwd = localStorage.getItem('loginpwd')
    }
    this.getChannelInfo()
  },
  methods: {
    touristLogin () {
      let data = {
        tourist: true,
      }
      CHANNEL_API.ChannelLOgin(data)
        .then(res => {
          if (res.code === 0) {
            localStorage.removeItem('pc' + this.loginName + 'channelName');
            localStorage.removeItem('pc' + this.loginName + 'logoUrl');
            localStorage.setItem('tourist', true)
            sessionStorage.setItem('tourist', true)

            setTimeout(() => {
              this.$router.push(
                {
                  name: 'MyCourseList',
                  params: res.data
                }
              )
              sessionStorage.setItem('channelLogin', JSON.stringify(res.data))
            }, 200)
            this.$message.success('登录成功')
          } else {
            console.log(res)
            this.$message.error(res.msg)
          }
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.log(err)
        })

    },

    getChannelInfo () {
      CHANNEL_API.ChannelFindInfo({ channelNo: this.$route.query.c_no }).then(res => {
        if (res.code === 0) {
          this.channelName = res.data.channelName
          this.logoUrl = res.data.logoUrl
          localStorage.setItem('channelInfo', JSON.stringify(res.data))
          localStorage.setItem('channelName', this.channelName)
          localStorage.setItem('logoUrl', this.logoUrl)
        }
      })
    },
    loginSubmit () {
      this.isLoading = true
      let data = {
        loginName: this.loginName,
        password: this.$md5(this.loginpwd),
        loginType: 0, // 记录动作
        platform: 'pc'
      }
      CUSTOMER_API.Login(data)
        .then(res => {
          if (res.code === 0) {
            let result = res.data
            // success
            localStorage.setItem('shangke_token', result.rememberToken)
            localStorage.setItem('shangke_username', result.loginName)
            localStorage.setItem('user_avatar', result.avatar)
            localStorage.setItem('nickname', result.nickname)
            sessionStorage.setItem('activeIndex', 1)
            sessionStorage.setItem('nickname', result.nickname)
            sessionStorage.setItem('tourist', false)
            localStorage.setItem('tourist', false)
            if (this.isRememberPwd) {
              localStorage.setItem('shangke_username', this.loginName)
              localStorage.setItem('loginpwd', this.loginpwd)
              localStorage.setItem('isRememberPwd', true)
            } else {
              localStorage.setItem('isRememberPwd', false)
            }

            localStorage.removeItem('pc' + this.loginName + 'channelName');
            localStorage.removeItem('pc' + this.loginName + 'logoUrl');
            this.$router.push('/pc/MyCourseList')
            this.$message.success('登录成功')
          } else {
            console.log(res)
            this.$message.error(res.msg)
          }
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.log(err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.login-box {
  height: 100%;
  width: 100%;
  background: url(~@/assets/img/login/bg.png) center/100% 100% no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  .info-img {
    width: 100px;
    border-radius: 10px;
  }
  .header-info {
    display: flex;
    height: 66px;
    margin-bottom: 50px;
    justify-content: center;
    align-items: center;
    .line {
      margin: 0 20px;
      display: inline-block;
      width: 1px;
      height: 80%;
      background: #ffffff;
    }
  }
  .login-form {
    .isRememberPwd-text {
      color: #ffffff;
    }
    .login-btn {
      width: 100%;
      height: 50px;
      color: #ffffff;
      background: rgba(8, 112, 234, 1);
      border-radius: 4px;
    }
    .info {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      .proxy-name {
        font-size: 30px;
        line-height: 28px;
        color: #ffffff;
      }
      .name {
        margin-top: 12px;
        font-size: 20px;
        line-height: 19px;
        color: #ffffff;
      }
    }
  }
}
</style>
